/**
 * @file 组件初始化入口
 */

import TSelect from './select.vue'

TSelect.install = Vue => {
  Vue.component(TSelect.name, TSelect)
}

export {
  TSelect
}



// WEBPACK FOOTER //
// ./src/module/select/index.js